export default "__VITE_ASSET__DTPR8wWq__"